import styled from "styled-components";

export const ScrollableVertical = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
